import { useState } from 'react';
import { useOverlayContext } from 'seagull';
import { useAddContactToClient } from '~/hooks/reactQuery/queries/useContactSummaryMutations';
import { useLocaleKeys } from '~/i18n';
import { CLIENT_FIELD_NAME, ROLE_FIELD_NAME, addContactToClientModalTextsPath } from '../AddContactToClientModal.utils';
export const useLinkContactToClient = (param)=>{
    let { contact, dismissModal, successToastTestId } = param;
    const { t } = useLocaleKeys(addContactToClientModalTextsPath);
    const { showSuccessToast } = useOverlayContext();
    const { addContactToClient } = useAddContactToClient();
    const [errorMessage, setErrorMessage] = useState(null);
    const linkContact = async (values)=>{
        setErrorMessage(null);
        try {
            await addContactToClient({
                contactId: contact.contactId,
                customerId: values[CLIENT_FIELD_NAME],
                // WHY: the picker registers `required`, so handleSubmit never reaches here with an unset role
                role: values[ROLE_FIELD_NAME]
            });
        } catch (unused) {
            setErrorMessage(t.saveError());
            return;
        }
        showSuccessToast(t.contactAdded(), successToastTestId);
        dismissModal();
    };
    return {
        errorMessage,
        linkContact
    };
};
